<template>
  <div class="w-full">
    <button
      type="button"
      :class="collapsible({ variant })"
      :aria-expanded="modelValue"
      @click="toggleOpen"
    >
      <span class="flex items-center gap-2 font-medium">
        <slot name="title">{{ title }}</slot>
        <span :class="collapsibleArrow({ open: modelValue })" aria-hidden="true">
          <ChevronRightIcon class="size-4" />
        </span>
      </span>
    </button>
    <div v-show="modelValue" class="pt-2">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ChevronRightIcon } from 'lucide-vue-next';
import { collapsible, collapsibleArrow } from '../../../theme/lib/cva/collapsible.ts';
import type { CvaComponentProps } from '@carvia/theme/lib/cva/CvaComponentProps';

const props = withDefaults(
  defineProps<{
    modelValue?: boolean;
    title?: string;
    variant?: CvaComponentProps<typeof collapsible>['variant'];
  }>(),
  {
    modelValue: false,
    variant: 'default',
  },
);

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
}>();

const toggleOpen = () => {
  emit('update:modelValue', !props.modelValue);
};
</script>
